import IconType from "@/types/Icon.type";
import IconDeckPassengerClass from "@Icons/ticket/passengerClass/IconDeckPassengerClass";
import IconSeatPassengerClass from "@Icons/ticket/passengerClass/IconSeatPassengerClass";
import IconCabinPassengerClass from "@Icons/ticket/passengerClass/IconCabinPassengerClass";

interface IconPassengerClassProps extends IconType {
    title?: "IconDeck" | "IconSeat" | "IconCabin"
}

function IconPassengerClass(props: IconPassengerClassProps) {
    const {
        title,
    } = props

    const matchedPassengerClass = {
        IconDeck: IconDeckPassengerClass,
        IconSeat: IconSeatPassengerClass,
        IconCabin: IconCabinPassengerClass,
    }

    const PassengerClassIcon = matchedPassengerClass[title]

    if (PassengerClassIcon) {
        return (
            <PassengerClassIcon
                {...props}
            />
        )
    }

    return null
}

export default IconPassengerClass